var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiAlertFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51698 17L10.575 5.21699C10.7236 4.97215 10.9328 4.76974 11.1824 4.62927C11.432 4.4888 11.7136 4.41501 12 4.41501C12.2864 4.41501 12.568 4.4888 12.8176 4.62927C13.0672 4.76974 13.2764 4.97215 13.425 5.21699L20.483 17C20.6284 17.252 20.7053 17.5377 20.7061 17.8287C20.7069 18.1197 20.6314 18.4058 20.4873 18.6586C20.3432 18.9114 20.1355 19.1221 19.8847 19.2697C19.634 19.4173 19.3489 19.4967 19.058 19.5H4.94198C4.6509 19.497 4.36569 19.4178 4.11475 19.2702C3.86382 19.1227 3.65592 18.912 3.51177 18.6591C3.36762 18.4062 3.29225 18.1199 3.29316 17.8288C3.29407 17.5377 3.37124 17.252 3.51698 17ZM12 8.99999C12.2652 8.99999 12.5196 9.10534 12.7071 9.29288C12.8946 9.48042 13 9.73477 13 9.99999V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1053 13.5196 11 13.2652 11 13V9.99999C11 9.73477 11.1053 9.48042 11.2929 9.29288C11.4804 9.10534 11.7348 8.99999 12 8.99999ZM11 16C11 15.7348 11.1053 15.4804 11.2929 15.2929C11.4804 15.1053 11.7348 15 12 15H12.008C12.2732 15 12.5276 15.1053 12.7151 15.2929C12.9026 15.4804 13.008 15.7348 13.008 16C13.008 16.2652 12.9026 16.5196 12.7151 16.7071C12.5276 16.8946 12.2732 17 12.008 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1053 16.5196 11 16.2652 11 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiAlertFill);
export default __webpack_public_path__ + "static/media/si_alert-fill.09760ca0b37bdd0b9be2735a0acb951e.svg";
export { ForwardRef as ReactComponent };